import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Select, Tabs, Alert, DatePicker, Col, Row, Tooltip } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import '../css/form.css';
import EditableTable from '../components/EditableTable';
import { entriesColumns } from '../utils/tableMockData';
import { MdPublish } from "react-icons/md";
import { BiReset } from "react-icons/bi";
import { FaCloudArrowUp } from "react-icons/fa6";
import EventEmitter from '../utils/eventEmitter';
import dayjs from 'dayjs';
import { Badge } from 'flowbite-react';
import useCustomerInvoiceAPI from '../apis/customerInvoiceAPI';
import CreditNoteModal from '../modals/CreditNoteModal';
import InvoiceTable from '../components/InvoiceTable';
import EntryTable from '../components/EntryTable';
import RegisterPaymentModal from '../modals/RegisterPaymentModal';
import Ribbon, { RibbonText } from '../../globalComponents/Ribbon';
// import customParseFormat from 'dayjs/plugin/customParseFormat';
// dayjs.extend(customParseFormat);

export const invoiceColumns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    key: 'product_id',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Label',
    dataIndex: 'label',
    key: 'label',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Account',
    dataIndex: 'account_id',
    key: 'account',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Analytics',
    dataIndex: 'analytics',
    key: 'analytics',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '10%'
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '10%'
  },
  {
    title: 'Taxes',
    dataIndex: 'taxes',
    key: 'taxes',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '15%'
  },
  {
    title: 'Subtotal',
    dataIndex: 'subtotal',
    key: 'subtotal',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    width: '10%'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  },
];




const CustomerInvoiceChanges = () => {
  const { journals, accounts, taxes, analytics, entry, invoice, contacts } = useLoaderData();
  invoice['invoice_date'] = invoice.invoice_date ? dayjs(invoice['invoice_date'], 'YYYY-MM-DD') : '';
  invoice['due_date'] = invoice.due_date ? dayjs(invoice['due_date'], 'YYYY-MM-DD') : '';
  // console.log(invoice);
  const [invoiceLines, setInvoiceLines] = useState(invoice.line_items ? invoice.line_items : []);
  const [journalEntries, setJournalEntries] = useState(entry.transactions ? entry.transactions : []);
  const [formValue, setFormValue] = useState(invoice.status ? {status: invoice.status} :{status: 'null'});
  const [tax, setTax] = useState([]);
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const params = useParams();
  const [alert, setAlert] = useState({message: '', status: ''});
  const navigate = useNavigate();
  const { save, postInvoice,update, deleteRecord, createAndPost, saveCreditNote, resetToDraft } = useCustomerInvoiceAPI();
  const [journalDefaultAccount, setJournalDefaultAccount] = useState({});


  const onChangeJournal = opt => {
    setJournalDefaultAccount(opt);
  }
 
  const handleDelete = () => {
    deleteRecord(invoice.number.replaceAll('/', '-'), success, navigate);
  }

  const handleCreate = () => {
    let data = {...form.getFieldsValue()};
    data['invoice_date'] = new Date(dayjs(data.invoice_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['due_date'] = new Date(dayjs(data.due_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['line_items'] = invoiceLines;
    let journal_code = journals.find(journal => journal._id === data.journal_id).code;
    const journalEntry = {
      reference: data.reference,
      accounting_date: data.invoice_date,
      journal_id: data.journal_id,
      journal_code,
      transactions: [...journalEntries],
    };

    // let analyticItems = [];
    // invoiceLines.forEach(entry => {
    //   if (entry.analytics) {
    //     entry.analytics.forEach(analyticId => {
    //       let itemObject = {
    //         description: data.reference, 
    //         analytic_account_id: analyticId,
    //         date: data.invoice_date,
    //         amount: entry.subtotal,
    //         reference: '',
    //         quantity: entry.quantity,
    //         product: entry.product_id,
    //         journal_item_number: '',
    //         account_id: entry.account_id
    //       };
    //       analyticItems.push(itemObject);
    //     });
    //   }
    // });
    // console.log(analyticItems)
    // console.log(journalEntry);
    save({invoice: data, entry: journalEntry}, success);
  }

  const handleConfirm = () => {
    let data = {...form.getFieldsValue()};
    data['invoice_date'] = new Date(dayjs(data.invoice_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['due_date'] = new Date(dayjs(data.due_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['line_items'] = invoiceLines;
    data['status'] = 'posted';
    let journal_code = journals.find(journal => journal._id === data.journal_id).code;
    const journalEntry = {
      reference: data.reference,
      accounting_date: data.invoice_date,
      journal_id: data.journal_id,
      journal_code,
      status: 'posted',
      transactions: [...journalEntries],
    };
    // let analyticItems = [];
    // invoiceLines.forEach(entryLine => {
    //   if (entryLine.analytics) {
    //     entryLine.analytics.forEach(analyticId => {
    //       let itemObject = {
    //         description: data.reference, 
    //         analytic_account_id: analyticId,
    //         date: data.invoice_date,
    //         amount: entryLine.subtotal,
    //         reference: '',
    //         quantity: entryLine.quantity,
    //         product: entryLine.product_id,
    //         journal_item_number: entry._id,
    //         account_id: entryLine.account_id
    //       };
    //       analyticItems.push(itemObject);
    //     });
    //   }
    // });
    // console.log(data)
    // console.log(journalEntry);
    postInvoice(invoice.number.replaceAll('/', '-'), {invoice: data, entry: journalEntry}, success);
  }

  const resetDraft = () => {
    resetToDraft(invoice.number, {entry: {accounting_date: invoice.invoice_date}}, success);
  }

  useEffect(() => {
    EventEmitter.subscribe('saved_invoice_response', data => {
      navigate('/accounting/invoices/'+data.number.replaceAll('/', '-'));
      setFormValue({...formValue, status: 'draft'});
    });

    EventEmitter.subscribe('invoice_posted', data => {
      navigate('/accounting/invoices/'+data.number);
      setFormValue({...formValue, status: data.status});
    });
    
    EventEmitter.subscribe('invoice_reset', data => {
      navigate('/accounting/invoices/'+data.number);
    })

    EventEmitter.subscribe('creating_credit_debit_note', async data_ => {
      let data = {...form.getFieldsValue()};
      data['invoice_date'] = new Date(dayjs(data.invoice_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
      data['due_date'] = new Date(dayjs(data.due_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
      data['line_items'] = invoiceLines;
      data['reason'] = data_.reason;
      data['reference'] = `Reversal of ${data.payment_reference}`
      const number_ = data.reference.split(' ')[2];
      data['status'] = 'draft';
      let entries = [];
      entry.transactions.forEach((entry, idx) => {
        let obj = {...entry};
        if (obj.type === 'credit') {
          obj.type = 'debit';
        }else if (obj.type === 'debit'){
          obj.type = 'credit';
        }
        entries.push(obj);
      });
      let journal_code = journals.find(journal => journal._id === data.journal_id).code;
      const journalEntry = {
        reference: data.reference,
        accounting_date: data.invoice_date,
        journal_id: data.journal_id,
        journal_code,
        status: 'draft',
        transactions: [...journalEntries],
      };
      
      if (data_.reversal_date === 'specific') {
        data['refund_date'] = new Date(data_['refund_date']).toLocaleDateString();
      }else if (data_.reversal_date === "journal_entry_date") {
        data['refund_date'] = data['invoice_date'];
      };

      switch (data_.credit_method) {
        case "partial_refund":
          // create new credit note draft
          const number = await saveCreditNote({invoice: data, entry: journalEntry}, success)
          await update(number_.replaceAll('/', '-'), {reversed: true}, success)
          if (number) navigate('/accounting/credit-notes/'+number.replaceAll('/', '-'));
          break;

        case "full_refund":
          // create and validate credit note to posted
          journalEntry['status'] = 'posted';
          data['status'] = 'posted';

          const createdNumber = await createAndPost({invoice: data, entry: journalEntry}, success)
          await update(number_.replaceAll('/', '-'), {reversed: true}, success);
          if (createdNumber) navigate('/accounting/credit-notes/'+createdNumber.replaceAll('/', '-'));
          break;

        case "full_refund_new_invoice":
          // create and validate credit note to posted and draft new invoice
          journalEntry['status'] = 'posted';
          data['status'] = 'posted';

          const createdNumber_ = await createAndPost({invoice: data, entry: journalEntry}, success)
          await update(number_.replaceAll('/', '-'), {reversed: true}, success);
          if (createdNumber_) navigate('/accounting/invoices/new');
          break;
      }
    });

    EventEmitter.subscribe('invoice_error', data => {
      setAlert({...alert, message: data});
      setTimeout(() => {
        setAlert({...alert, message: ''});
      }, 5000);
    });

    return () => { 
      EventEmitter.unsubscribe('saved_invoice_response');
      EventEmitter.unsubscribe('invoice_posted');
      EventEmitter.unsubscribe('creating_credit_debit_note');
      EventEmitter.unsubscribe('invoice_error')
    }
  }, [])


  const handleAddCreditNote = () => {
    EventEmitter.dispatch('invoice_credit_note', true);
  }

  const handleRegisterPayment = () => {
    EventEmitter.dispatch('register_payment', {
      open: true,
      date: invoice.invoice_date,
      number: invoice.number,
      amount: invoiceLines.reduce((prev, current) => (current.subtotal + prev), 0),
      partner_type: 'customer',
      credit_note: false,
      partner_id: invoice.customer_id
    });
  }

  const handleClose = () => setAlert('');
  
  return (
    <div className='container mx-auto' style={{ maxWidth: '1200px' }}>
      {alert.message !== '' && (
        <Alert message={alert.message} type={'error'} closable showIcon afterClose={handleClose} />
      )}
      <div className='flex justify-between mb-3'>
        <div className='flex '>
          <h3 className='font-bold'>
            <Link to={'/accounting/invoices'} className='whitespace-nowrap hover:underline font-medium text-sky-600 dark:text-white'>Invoices</Link> / {params.action} 
          </h3>
          <Tooltip
            title='save manually'
            placement='rightBottom'
            className='ms-1'
          >
            <Button onClick={handleCreate} type='text' htmlType='button'
              disabled={formValue.status === 'posted' || formValue.status === 'draft' ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          
        </div>
        {invoice.number && <div className='bg-red-500 rounded'>
          <Button type='text' className='font-semibold' onClick={handleDelete}>Delete</Button>
        </div>}
        {/* <div class="arrow-block">
          <div class="arrow"></div>
          <div class="content">
            Your content goes here
          </div>
        </div> */}
        {/* <div class="arrow-block posted">
          <div class="arrow"></div>
          <div class="content">
            Posted
          </div>
        </div>

        <div class="arrow-block draft">
          <div class="arrow"></div>
          <div class="content">
            Draft
          </div>
        </div> */}
      </div>
      <div className='flex justify-between align-center'>
        <div>
          {formValue.status === 'draft' && <div>
            <Button htmlType='button' onClick={handleConfirm} >CONFIRM</Button> 
            <Button htmlType='button' className='mx-1'>CANCEL</Button>
          </div>}
          {(formValue.status === 'posted' && invoice.payment === undefined) ? <div>
            <Button htmlType='button' >SEND & PRINT</Button> 
            {!invoice.reversed &&<> <Button htmlType='button' onClick={handleRegisterPayment} className='mx-1'>REGISTER PAYMENT</Button>
            <Button htmlType='button' className='mx-1'>PREVIEW</Button>
            <Button htmlType='button' onClick={handleAddCreditNote} className='mx-1'>ADD CREDIT NOTE</Button>
            <Button htmlType='button' className='mx-1' onClick={resetDraft}>RESET TO DRAFT</Button></>}
          </div>:
            (formValue.status === 'posted' && invoice.payment !== undefined) &&
            <Button htmlType='button' onClick={handleAddCreditNote} className='mx-1'>ADD DEBIT NOTE</Button>
          }
        </div>
        {formValue.status !== 'null' && (
          <div id='status-container '>
            <ul className='inner-wrapper'>
              <li
                className={
                  formValue.status === 'draft'
                    ? 'draft-disabled first draft draft-status'
                    : 'first draft-status draft-transparent'
                }
              >
                DRAFT
              </li>
              <li
                className={
                  formValue.status === 'posted'
                    ? 'posted posted-status'
                    : 'posted-status posted-transparent'
                }
              >
                POSTED
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className='mt-5 bg-white'>
        <div className='relative'>
          {invoice.payment !== undefined && <Ribbon text={invoice.payment} className={"bg-[#24ad32]"}/>}
        </div>
        <Form 
          form={form}
          className='shadow p-3' 
          initialValues={invoice.status ? invoice : {
            auto_post: false,
            to_check: false
          }}  
          labelAlign='left'
          labelCol={{span: 10}}
          autoComplete="off"
          variant='borderless'
          disabled={(formValue.status === 'posted') ? true : false}
        >
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label='Customer' name="customer_id" className='font-bold mb-2 ' required >
                <Select options={contacts.map(contact => ({ value: contact._id, label: contact.name}))} className='font-normal'  placeholder='Select name here' />
              </Form.Item>
              <Form.Item label='Delivery Address' name="delivery_address" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full'  placeholder='Enter address here'/>
              </Form.Item>
              <Form.Item label='Reference' name="reference" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' placeholder='Enter address here'/>
              </Form.Item>
            </Col>
            <Col md={{span: 11}}>
              <Form.Item label="Invoice Date" name="invoice_date" className='font-bold mb-2' required >
                <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal'  />
              </Form.Item>
              <Form.Item label='Payment Reference' name="payment_reference" className='font-bold mb-2 ' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal w-full' placeholder='Enter description here'/>
              </Form.Item>
              <Form.Item label="Due Date" name="due_date" className='font-bold mb-2' required >
                <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal'  />
              </Form.Item>
              <Form.Item label='Journal' name={'journal_id'} className='font-bold mb-2' required >
                <Select options={journals.map(journal => ({value: journal._id, label: journal.name, account: journal.default_account}))} onChange={(_, opt)=>onChangeJournal(opt)}  placeholder='select journal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            type='card'
            items={[
              {
                key: '1',
                label: 'Invoice Lines',
                children: <InvoiceTable name={'invoice'} dataSource={invoiceLines} default_account={journalDefaultAccount} invoiceNumber={form.getFieldValue('payment_reference')} setInvoiceLines={setInvoiceLines} entries={journalEntries} setJournalEntries={setJournalEntries} columns={invoiceColumns} accounts={accounts} taxes={taxes} setTax={setTax} tax={tax} products={[]} analytics={analytics} status={formValue.status}/>
              },
              {
                key: '2',
                label: 'Journal Items',
                children: <EntryTable dataSource={journalEntries} setJournalEntries={setJournalEntries} columns={entriesColumns} accounts={accounts} analytics={analytics} taxes={taxes} setTax={setTax} tax={tax} status={formValue.status}/>
              },
              {
                key: '3',
                label: 'Other Info',
                // active: true,
                children: 
                  <Form 
                    form={form}
                    initialValues={invoice.status ? {auto_post: invoice.auto_post, to_check: invoice.to_check} : {
                      auto_post: false,
                      to_check: false
                    }}  
                    labelAlign='left'
                    labelCol={{span: 10}}
                    autoComplete="off"
                    variant='borderless'
                    
                  >
                  <Row>
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-md bg-transparent	">INVOICE</Badge>
                      <Form.Item labelCol={{span: 5}} label='Salesperson' name={'salesperson'} className='font-bold ms-2'>
                        <Select options={[]} style={{width: '200px'}}/>
                      </Form.Item>
                    </Col>
                    <Col  md={{span: 10}}>
                      <Badge className="text-slate-500 text-md bg-transparent	">ACCOUNTING</Badge>
                      <Form.Item labelCol={{span: 7}} label='Auto-post' name={'auto_post'} valuePropName='checked' className='font-bold ms-2'>
                        <Checkbox />
                      </Form.Item>
                      <Form.Item labelCol={{span: 7}} label='To Check' name={'to_check'} valuePropName='checked' className='font-bold ms-2'>
                        <Checkbox />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              }
            ]}
          />
        </Form>
      </div>
      <RegisterPaymentModal />
      <CreditNoteModal />
    </div>
  )
}
export default CustomerInvoiceChanges;
